module.exports = __webpack_public_path__ + "assets/img/supportStore.b0193f2a.png";